import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Events from "@/pages/Events";
import EventDetails from "@/pages/EventDetails";
import HowItWorks from "@/pages/HowItWorks";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Safety from "@/pages/Safety";
import Terms from "@/pages/Terms";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ResetRequest from "@/pages/ResetRequest";
import ResetConfirm from "@/pages/ResetConfirm";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Questionnaire from "@/pages/Questionnaire";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminUserDetail from "@/pages/AdminUserDetail";
import DoorMode from "@/pages/DoorMode";
import MyTicket from "@/pages/MyTicket";
import VerifyAge from "@/pages/VerifyAge";
import ProtectedRoute from "@/components/ProtectedRoute";
import "@/App.css";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  // Door-mode is a full-screen admin tool meant for a phone at the venue — hide the public chrome.
  const isDoor = /^\/admin\/events\/[^/]+\/door/.test(location.pathname);
  return (
    <>
      {!isDoor && <Navbar />}
      <main className={isDoor ? "" : "min-h-[60vh]"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:id" element={<EventDetails />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/safety" element={<Safety />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/reset" element={<ResetRequest />} />
          <Route path="/reset-password" element={<ResetConfirm />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/verify-age" element={<ProtectedRoute skipAgeCheck><VerifyAge /></ProtectedRoute>} />
          <Route path="/dashboard/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/questionnaire" element={<ProtectedRoute><Questionnaire /></ProtectedRoute>} />
          <Route path="/admin/users/:userId" element={<ProtectedRoute admin><AdminUserDetail /></ProtectedRoute>} />
          <Route path="/admin/events/:eventId/door" element={<ProtectedRoute admin><DoorMode /></ProtectedRoute>} />
          <Route path="/tickets" element={<MyTicket />} />
          <Route path="/tickets/:code" element={<MyTicket />} />
          <Route path="/admin/*" element={<ProtectedRoute admin><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </main>
      {!isDoor && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
